import React, { useContext, useState, useCallback } from "react";

import { APIContext } from "../../API";

import { Status, StatusButton } from "../misc";
import InfoForm from "./InfoForm";

export default function EditInfo({ info, setInfo, close }) {
  const API = useContext(APIContext);

  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const [changed, setChanged] = useState(false);

  const setInfoAndMarkChanged = useCallback(
    (newInfo) => {
      setInfo(newInfo);
      setChanged(true);
    },
    [setInfo, setChanged]
  );

  function submit() {
    setError(null);

    if (!info.title) {
      return setError("Missing title");
    }

    if (!info.price) {
      return setError("Missing price");
    } else if (typeof info.price !== "number") {
      return setError("Invalid price");
    }

    if (!info.type) {
      return setError("Missing type");
    }

    if (!info.release_date) {
      return setError("Missing Release Date");
    }

    if (!info.slug) {
      return setError("Missing URL");
    } else if (!info.slug.match(/^\w+([-_]\w+)*$/)) {
      return setError("Invalid URL");
    }

    if (info.tags.length === 0) {
      return setError("Missing Tags");
    }

    setStatus("Submitting");
    API.editProduct(info, (err, response) => {
      setStatus(null);
      if (err) {
        return setError(err.response?.data?.msg || "Something went wrong");
      }
      close && close();
    });
  }

  return (
    <>
      <h2 className="mb-2">Edit Info</h2>
      <InfoForm info={info} setInfo={setInfoAndMarkChanged} />
      <Status error={error} />
      <StatusButton
        text="Submit"
        className="button"
        status={status}
        onClick={submit}
        disabled={!changed}
      />
    </>
  );
}
